import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { DISPUTE_REASONS } from '@/lib/leadDispute';

export function DisputeLeadModal({
  open,
  lead,
  onOpenChange,
  onSubmit,
  isSubmitting,
  error,
}) {
  const [motivo, setMotivo] = useState(DISPUTE_REASONS[0].value);
  const [note, setNote] = useState('');

  const handleOpenChange = (next) => {
    if (!next) {
      setMotivo(DISPUTE_REASONS[0].value);
      setNote('');
    }
    onOpenChange(next);
  };

  const handleConfirm = () => {
    onSubmit({ motivo, note: note.trim() });
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent
        className="max-w-md"
        style={{ backgroundColor: '#0A192F', border: '1px solid rgba(212, 175, 55, 0.35)', color: '#F8F9FA' }}
      >
        <DialogHeader>
          <DialogTitle style={{ color: '#F8F9FA', fontFamily: 'Playfair Display, serif' }}>
            Contesta Lead (Garanzia 24h)
          </DialogTitle>
          <DialogDescription style={{ color: '#A0ABC0' }}>
            {lead ? `${lead.nome || ''} ${lead.cognome || ''}`.trim() : 'Lead'} — storno crediti se la contestazione è valida.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="dispute-motivo" style={{ color: '#E2E8F0' }}>
              Motivazione
            </Label>
            <select
              id="dispute-motivo"
              value={motivo}
              onChange={(e) => setMotivo(e.target.value)}
              className="w-full text-sm rounded-md px-3 py-2 border-0 outline-none"
              style={{ backgroundColor: '#112240', color: '#F8F9FA' }}
              data-testid="dispute-motivo"
            >
              {DISPUTE_REASONS.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="dispute-note" style={{ color: '#E2E8F0' }}>
              Note (opzionale)
            </Label>
            <Textarea
              id="dispute-note"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              rows={3}
              className="resize-none"
              style={{ backgroundColor: '#112240', color: '#F8F9FA', borderColor: 'rgba(255,255,255,0.12)' }}
              data-testid="dispute-note"
            />
          </div>
          {error ? (
            <p className="text-sm" style={{ color: '#FCA5A5' }} role="alert">
              {error}
            </p>
          ) : null}
          <div className="flex justify-end gap-2">
            <Button type="button" variant="ghost" onClick={() => handleOpenChange(false)} style={{ color: '#A0ABC0' }}>
              Annulla
            </Button>
            <Button
              type="button"
              onClick={handleConfirm}
              disabled={isSubmitting}
              style={{ backgroundColor: '#D4AF37', color: '#0A192F' }}
              data-testid="dispute-confirm-btn"
            >
              {isSubmitting ? 'Invio...' : 'Conferma contestazione'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
